<template>
    <div class="card">
        <TabView @tab-change="handleTabChange">
            <TabPanel header="จัดกลุ่มตามช่วงเวลา">
                <statistic-organize-range-time></statistic-organize-range-time>
            </TabPanel>
			<TabPanel header="จัดกลุ่มตามหน่วยงานรับผิดชอบ">
                <statistic-organize-response></statistic-organize-response>
            </TabPanel>
            <TabPanel header="เปรียบเทียบสถิติเดือนเดียวกันในแต่ละปี">
                <statistic-organize-year></statistic-organize-year>
            </TabPanel>
        </TabView>
    </div>
</template>

<script>
import statisticOrganizeRangeTime from './StatisticOrganizeRangeTime';
import statisticOrganizeResponse from './StatisticOrganizeResponse';
import statisticOrganizeYear from './StatisticOrganizeYear';

export default {
    components: {
		statisticOrganizeRangeTime,
		statisticOrganizeResponse,
        statisticOrganizeYear
    },
    data() {
      return{
          
      }    
    },

    watch:{

    },

    mounted(){
    },

    methods: {
        handleTabChange(newTab){
            console.log(newTab.tab.$vnode.componentOptions.propsData.header)
        }
    }
}
</script>